// components/YearSelector.jsx
import React from 'react';
import { Col, Row, Select, Space } from 'antd';

const YearSelector = ({ selectedYear, years, onYearChange }) => (
  <Row style={{ textAlign: "right", marginBottom: 20 }}>
    <Col span={24}>
      <Space wrap>
        <Select
          defaultValue={selectedYear}
          style={{ textAlign: 'left', width: 120 }}
          onChange={onYearChange}
          options={years?.map(year => ({ value: year, label: year.toString() }))}
        />
      </Space>
    </Col>
  </Row>
);

export default YearSelector;